import type { ReactNode } from 'react'
import { FeedbackProvider } from './FeedbackContext'

/**
 * Global Quackback owner. Buttons open `new-post`; bell opens changelog.
 */
export default function FeedbackWidget({ children }: { children: ReactNode }) {
  return <FeedbackProvider>{children}</FeedbackProvider>
}
